export function validateCheckbox(checkboxInput) {
    function updateErrorMessage(displayError) {
        const errorMessage = document.getElementById('error-message-checkbox');
        errorMessage.style.display = displayError ? 'flex' : 'none';
        if (displayError) {
            checkboxInput.classList.add('form__checkbox--error');
        } else {
            checkboxInput.classList.remove('form__checkbox--error')
        }
    }

    checkboxInput.addEventListener('change', function () {
         const isValid = checkboxInput.checked;
         updateErrorMessage(!isValid);

        const checkboxValidityEvent = new CustomEvent('checkboxValidity', {
            detail: { isValid }
        });

        document.dispatchEvent(checkboxValidityEvent);
    });
}